import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import InvitePeopleSection from './InvitePeopleSection';
import MembersSection from './MembersSection/MembersSection';
import SelectedMemberSettings from './SelectedMemberSettings/SelectedMemberSettings';

const MembersTab = () => {
  const { t } = useTranslation();
  const [selectedMember, setSelectedMember] = useState<string | null>(null);
  const { workspacePermissions } = useWorkspacesContext();

  const handleMemberClose = () => setSelectedMember(null);

  if (selectedMember) return <SelectedMemberSettings memberId={selectedMember} onClose={handleMemberClose} />;

  return (
    <div className="flex flex-col space-y-4">
      <span className="text-xl font-semibold">{t('workspaces.members')}</span>
      {workspacePermissions.invitePeople && <InvitePeopleSection />}
      <MembersSection onMemberSelect={setSelectedMember} />
    </div>
  );
};

export default MembersTab;
